var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.427 1.827A1.82 1.82 0 0 0 2.6 0C1.6 0 .773.813.773 1.827c0 .786.574 1.586 1.827 3.066 1.253-1.48 1.827-2.28 1.827-3.066zm3.893-.64H5.467c.04.2.066.414.066.627 0 1.24-.826 2.307-2.093 3.787l-.84.987-.84-.987C1 4.707.4 3.974.04 3.254c-.027.134-.04.28-.04.427v5.813c0 .614.227 1.174.587 1.614l8.986-9.574a2.45 2.45 0 0 0-1.253-.347zM1.426 11.743c.333.16.693.254 1.08.254h5.813a2.498 2.498 0 0 0 2.493-2.494V8.25H4.72l-3.293 3.493zm4.281-4.546L10.36 2.25c.28.4.454.893.454 1.44v3.507H5.707zm-3.12-6.158c-.48 0-.88.4-.88.88s.4.88.88.88.88-.4.88-.88-.4-.88-.88-.88z",
    fill: "#65707B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default ForwardRef;